<template>
    <v-layout class="mission-container" column>       
       <v-tabs align-with-title slider-color="#ddd">        
        <v-tab class="missiontab" exact :to="'/pilot/mission/'+mission.misId" v-for="{mission} in detailMissions" :key="mission.misId">
          <mission-state :mission="mission" class="pr-2" />
          {{ mission.misLibelle }}          
          <v-spacer /><v-btn class="mr-0" small icon @click.prevent.stop="$store.myActions.MISSION_UNSELECT_DETAIL(mission.misId)" :title="$t('Pilot.MissionInfos.CloseMissionTabTooltip')"><v-icon small>mdi-close</v-icon></v-btn>
        </v-tab>
        <v-tab class="missionmore" exact to="/pilot/mission" :title="$t('Pilot.MissionInfos.AddMissionTabTooltip')"><v-icon>mdi-plus</v-icon></v-tab>
        <v-spacer />
        <v-tab exact to="/pilot">{{$t('Pilot.MissionInfos.BackToMap')}}</v-tab>
      </v-tabs>      
      <router-view/>
    </v-layout>
</template>
<script>
  import { mapGetters } from 'vuex'
  import MissionState from '@/components/mission/MissionState'
  export default {
    name: 'Mission',          
    components:{MissionState},
    computed:{
      ...mapGetters([
         'detailMissions'
      ])
    },
    methods:{
    },
    watch:{
      detailMissions(newValue){
        //si l'onglet fermé est l'onglet en cours on navigue sur la page précédente        
        if(this.$route.params.missionid && 
          newValue.findIndex(it => it.mission.misId == this.$route.params.missionid) == -1
        ) {          
          this.$router.push('/pilot/mission/'+(newValue.length > 0?newValue[0].mission.misId:""))
        }        
      }
    }
  }
</script>

<style scoped>
  .mission-container{    
    position: absolute;
    top: 0; bottom: 0; left: 0; right: 0;
    overflow: hidden;
  }
  .missiontab, .missionmore{
    border-right:1px solid #efefef;
  }
  .missiontab  .v-tabs__item{
    padding-right: 0;
  }   
  
</style>

<style>
  .missiontab .v-tabs__item--active,.missionmore .v-tabs__item--active{
    background-color:#ddd;
  }
  
</style>